import { View } from 'react-native'
import TileGlass from '@ui/tiles/TileGlass'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'
import { colors } from '@ui/colors'
import Gradient from '@ui/effects/Gradient'
import { SharedValue } from 'react-native-reanimated'
import { BlurMode } from '@ui/tiles/TileGlass/types'

interface Props {
  title: string
  image?: string
  desc?: string | null
  children?: React.ReactNode
  magicGlow?: boolean
  animation?: SharedValue<number>
  blurMode?: BlurMode
  borderRadius?: number
}

export default function Banner({
  image,
  title,
  desc,
  children,
  magicGlow,
  animation,
  blurMode,
  borderRadius = 24,
}: Props) {
  return (
    <View
      className="overflow-hidden border border-black/10"
      style={{ borderRadius }}
    >
      <TileGlass
        borderRadius={borderRadius}
        style={{
          width: '100%',
          borderWidth: 0,
          borderRadius: 0,
        }}
        image={image}
        animation={animation}
        imageStyle={{
          transform: [{ translateX: 1 }],
        }}
        blurMode={blurMode}
        blur={50}
        magicGlow={magicGlow}
        className="overflow-hidden-fixer"
        blurContentFit="fill"
        blurClassName="bottom-0 left-0 top-0 right-0"
        blurStyle={{ opacity: 0.75, transform: [{ scaleY: 1.1 }] }}
        gradient={
          <Gradient
            style={{ transform: [{ scaleY: 1.2 }] }}
            colors={[colors.gray[75], colors.white, colors.white0]}
            start={[0, 0.25]}
            end={[1, 0.75]}
          />
        }
      >
        {/* <Border /> */}
        <View
          className={cn(
            'w-2/3 justify-center gap-1 py-12 pl-12 pr-8 text-left'
          )}
        >
          <Typography variant="MDB" className="color-text">
            {title}
          </Typography>
          <Typography variant="SM" className="color-desc">
            {desc}
          </Typography>
        </View>
      </TileGlass>
      {children}
    </View>
  )
}
